import React from 'react';
import {Dropdown, Input, Layout} from 'antd';
import {useTranslation} from 'react-i18next';
import PropTypes from 'prop-types';
import {FiMoreVertical} from 'react-icons/fi';
import {AiOutlineMenu} from 'react-icons/ai';

import AppLogo from '../components/AppLogo';
import AppNotifications from '../../AppNotifications';

import './index.style.less';

const {Header} = Layout;
const {Search} = Input;

const AppHeader = ({isCollapsed, onToggleSidebar}) => {
  const {t} = useTranslation();

  const menuMobile = [
    {
      label: <AppNotifications />,
      key: 'more-icon',
    },
  ];

  return (
    <Header className='app-header'>
      <a className='trigger' onClick={() => onToggleSidebar(!isCollapsed)}>
        <AiOutlineMenu />
      </a>
      <AppLogo />
      <Search
        className='header-search'
        placeholder={t('int-enter-search-text')}
      />
      <div className='app-header-sectionDesktop'>
        <AppNotifications />
      </div>
      <div className='app-header-section-mobile'>
        <Dropdown menu={{items: menuMobile}} trigger={['click']}>
          <a className='ant-dropdown-link' onClick={(e) => e.preventDefault()}>
            <FiMoreVertical />
          </a>
        </Dropdown>
      </div>
    </Header>
  );
};

export default AppHeader;

AppHeader.propTypes = {
  onToggleSidebar: PropTypes.func,
  isCollapsed: PropTypes.bool,
};
